module.exports = __webpack_public_path__ + "static/media/member4.ecf0d6e0.jpg";